/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: NonNullable<unknown> }} Confirm_DeletionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {resource}?" |
*
* @param {Confirm_DeletionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_deletion = /** @type {((inputs: Confirm_DeletionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_DeletionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.resource}?`)
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer ${i?.resource} ?`)
});